import React from "react";

class EmptyColumnPlaceholder extends React.PureComponent {
  render() {
    return <span className="empty-column-placeholder">---</span>;
  }
}

export default EmptyColumnPlaceholder;
